module.exports = __webpack_public_path__ + "media/8_5.e30c6ce5.wav";